import React from 'react';
import styled from 'styled-components';

import noPhotoPlaceHolder from '@assets/icons/no-photo-placeholder.png';

// Do not change this styles usage, it's for css precedence.
const errorImageStyles = {
  position: 'initial',
  width: 'auto',
  margin: 'auto',
  maxWidth: '50px',
  maxHeight: '50px',
};

const ErrorImageContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  height: 100%;
`;

function ErrorImage(props) {
  return (
    <ErrorImageContainer>
      <img
        src={noPhotoPlaceHolder}
        aria-hidden="true"
        style={errorImageStyles}
        {...props}
      />
    </ErrorImageContainer>
  );
}

export default ErrorImage;
